<template>
  <v-container style="width: 100%;">
    <v-layout justify-space-between>
      <h1>SumUP Integration</h1>
      <v-btn
        href="https://sumup.co.uk"
        target="_blank"
        color="green"
        dark
        class="text-none"
      >Go to SumUP</v-btn>
    </v-layout>
    <v-layout pt-3 justify-center>
      <v-flex xs12 md8>
        <SimpleCard>
          <v-layout column>
            <h3>SumUP Account</h3>
            <p
              v-if="sumupResponse != null && sumupResponse.error != null"
            >Your SumUP account is not yet linked</p>
            <p
              v-if="sumupResponse != null && sumupResponse.account != null"
            >Your SumUP account is linked correctly</p>
            <p v-if="sumupResponse != null && sumupResponse.account != null">
              <b>Email:</b>
              {{sumupResponse.account.username}}
            </p>
            <p v-if="sumupResponse != null && sumupResponse.account != null">
              <b>Company Name:</b>
              {{sumupResponse.merchant_profile.company_name}}
            </p>
            <v-btn
              v-if="sumupResponse != null && sumupResponse.account == null"
              large
              class="text-none"
              dark
              color="green"
              :href="sumupAuthString"
            >Link SumUP Account</v-btn>
            <v-btn
              v-if="sumupResponse != null && sumupResponse.account != null"
              large
              class="text-none"
              :href="sumupAuthString"
            >Reconnect / Connect New SumUP account</v-btn>
          </v-layout>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";
import FixedCostList from "@/components/settings/pricing/FixedCostList.vue";
import SimpleCard from "@/components/widget/SimpleCard";

import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "fixed_pricing",
  components: {
    Overview,
    SimpleCard,
    FixedCostList
  },
  data: function() {
    return {
      sumupResponse: null
    };
  },
  computed: {
    sumupAuthString: function() {
      var authString = "https://api.sumup.com/authorize?response_type=code";

      authString += "&client_id=" + this.sumupResponse.client_id;
      authString +=
        "&redirect_uri=" +
        `${this.$store.state.apiUrl}/third_party/sumup/oauth_callback`;

      authString +=
        "&scope=payments user.app-settings transactions.history user.profile_readonly";

      return authString;
    }
  },
  methods: {
    create: function() {
      this.$router.push("/settings/pricing/fixed_cost/create");
    }
  },
  mounted: async function() {
    try {
      var url = `${this.$store.state.apiUrl}/third_party/sumup/get`;

      let response = await axios.get(url, {
        params: {}
      });

      this.sumupResponse = response.data;
    } catch (error) {
      this.loading = false;
      console.log("Failed to get history");
    }
  }
};
</script>
